import {
  Box,
  Button,
  FormControl,
  Grid,
  MenuItem,
  Select,
  Slider,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { UserCommonStyles } from "../../styles/CommonStyles";
import LeftSidebar from "../../components/sidebars/LeftSidebar";
import Minus from "../../images/minus-square.png";
import Plus from "../../images/Add.png";
import { useTranslation } from "react-i18next";
import { CommonButton } from "../../stories/Button";
import { styled } from "@mui/material/styles";
import SocialIconSection from "../../components/sidebars/SocialIconSection";
import moment from "moment";
import { RoutingLinks } from "../../utils/constants";
import { useHistory } from "react-router-dom";
import { calculateDateDifferences } from "../../utils/helper";

const budgetDropdown = [{ option: "Daily" }];

const CustomizedSlider = styled(Slider)`
  color: #01b4bc;
  height: 8px;

  & .MuiSlider-thumb {
    border-radius: 50px;
    color: #fff;
    width: 22px;
    height: 22px;
  }

  & .MuiSlider-rail {
    // border-radius: 50px;
    background-color: #bdbdbd;
    height: 10px;
  }
`;

const SettingBudget: React.FC<any> = (props: any) => {
  const {
    isPromote,
    isEdit,
    paidOrUnpaidAmount,
    setPaidOrUnpaidAmount,
    totalAmount,
    setTotalAmount,
    budgetValue,
    setBudgetValue,
    budgetPerDay,
    setBudgetPerDay,
    days,
    setDays,
    views,
    setViews,
    clicks,
    setClicks,
    isRunningAd,
    adStartDate,
    adEndDate,
    setFormHandler,
  } = props;

  const viewAndClickRate = 4;

  const commonStyle = UserCommonStyles();
  const { t: translation } = useTranslation();
  const history = useHistory();

  const [step2ValidationErrors, setStep2ValidationErrors] = useState<any>({
    budgetValueError: "",
    endDateError: "",
  });

  useEffect(() => {
    setDays((prev: any) => ({
      ...prev,
      current:
        calculateDateDifferences(adStartDate?.current, adEndDate?.current) + 1,
    }));
  }, [adStartDate, adEndDate]);

  const handleViewAndCliks_andSetPaidOrUnpaidAmount = () => {
    if (isEdit && !isRunningAd?.isRunning) {
      // ad befor continue and calculate the paid or unpaid amount and set views and clicks in edit conditions
      if (
        days?.current === days?.previous &&
        budgetPerDay?.current === budgetPerDay?.previous
      ) {
        console.log("case 1");
        //1 when days and budget still constant
        setViews((prev: any) => ({
          ...prev,
          current: budgetPerDay?.current * viewAndClickRate,
        }));
        setClicks((prev: any) => ({
          ...prev,
          current: budgetPerDay?.current * viewAndClickRate,
        }));
        setPaidOrUnpaidAmount((prev: any) => ({
          ...prev,
          unpaidAmount: 0,
          dividedAmountPerDay: 0,
        }));
      } else if (
        //2 when days will extend but per day budget will constant
        days?.previous < days?.current &&
        budgetPerDay?.previous === budgetPerDay?.current
      ) {
        console.log("case 2");
        setViews((prev: any) => ({
          ...prev,
          current: budgetPerDay?.current * viewAndClickRate,
        }));
        setClicks((prev: any) => ({
          ...prev,
          current: budgetPerDay?.current * viewAndClickRate,
        }));
        setPaidOrUnpaidAmount((prev: any) => ({
          ...prev,
          dividedAmountPerDay: 0,
          unpaidAmount:
            (days?.current - days?.previous) * budgetPerDay?.current,
        }));
        setTotalAmount((prev: any) => ({
          ...prev,
          current: days?.current * budgetPerDay?.current,
        }));
      } else if (
        // 3 when days will reduce, per day budget is constan
        days?.previous > days?.current &&
        budgetPerDay?.previous === budgetPerDay?.current
      ) {
        let cal =
          (days?.previous * budgetPerDay?.previous -
            days?.current * budgetPerDay?.previous) /
          days?.current;
        console.log("case 3");
        setViews((prev: any) => ({
          ...prev,
          current: (cal + budgetPerDay?.current) * viewAndClickRate,
        }));
        setClicks((prev: any) => ({
          ...prev,
          current: (cal + budgetPerDay?.current) * viewAndClickRate,
        }));
        setPaidOrUnpaidAmount((prev: any) => ({
          ...prev,
          dividedAmountPerDay: cal,
          unpaidAmount: 0,
        }));
      } else if (
        // 4 when days will constant, per day budget decrease
        days?.previous === days?.current &&
        budgetPerDay?.previous > budgetPerDay?.current
      ) {
        console.log("case 4");
        setViews((prev: any) => ({
          ...prev,
          current: budgetPerDay?.current * viewAndClickRate,
        }));
        setClicks((prev: any) => ({
          ...prev,
          current: budgetPerDay?.current * viewAndClickRate,
        }));
        setPaidOrUnpaidAmount((prev: any) => ({
          ...prev,
          unpaidAmount: 0,
          dividedAmountPerDay: 0,
        }));
      } else if (
        // 5 when days will constant, per day budget increase
        days?.previous === days?.current &&
        budgetPerDay?.previous < budgetPerDay?.current
      ) {
        console.log("case 5");
        setViews((prev: any) => ({
          ...prev,
          current: budgetPerDay?.current * viewAndClickRate,
        }));
        setClicks((prev: any) => ({
          ...prev,
          current: budgetPerDay?.current * viewAndClickRate,
        }));
        setPaidOrUnpaidAmount((prev: any) => ({
          ...prev,
          dividedAmountPerDay: 0,
          unpaidAmount:
            (budgetPerDay?.current - budgetPerDay?.previous) * days?.current,
        }));
        setTotalAmount((prev: any) => ({
          ...prev,
          current: days?.current * budgetPerDay?.current,
        }));
      } else if (
        // 6 when days and budget both increase
        days?.previous < days?.current &&
        budgetPerDay?.previous < budgetPerDay?.current
      ) {
        console.log("case 6");
        setViews((prev: any) => ({
          ...prev,
          current: budgetPerDay?.current * viewAndClickRate,
        }));
        setClicks((prev: any) => ({
          ...prev,
          current: budgetPerDay?.current * viewAndClickRate,
        }));
        setPaidOrUnpaidAmount((prev: any) => ({
          ...prev,
          dividedAmountPerDay: 0,
          unpaidAmount:
            days?.current * budgetPerDay?.current - prev?.paidAmount,
        }));
        setTotalAmount((prev: any) => ({
          ...prev,
          current: days?.current * budgetPerDay?.current,
        }));
      } else if (
        // 7 when days and budget both decrease
        days?.previous > days?.current &&
        budgetPerDay?.previous > budgetPerDay?.current
      ) {
        console.log("case 7");
        setViews((prev: any) => ({
          ...prev,
          current: budgetPerDay?.current * viewAndClickRate,
        }));
        setClicks((prev: any) => ({
          ...prev,
          current: budgetPerDay?.current * viewAndClickRate,
        }));
        setPaidOrUnpaidAmount((prev: any) => ({
          ...prev,
          dividedAmountPerDay: 0,
          unpaidAmount: 0,
        }));
      } else if (
        // 8 when days extend and budget decrease
        days?.previous < days?.current &&
        budgetPerDay?.previous > budgetPerDay?.current
      ) {
        console.log("case 8");
        setViews((prev: any) => ({
          ...prev,
          current: budgetPerDay?.current * viewAndClickRate,
        }));
        setClicks((prev: any) => ({
          ...prev,
          current: budgetPerDay?.current * viewAndClickRate,
        }));
        setPaidOrUnpaidAmount((prev: any) => ({
          ...prev,
          dividedAmountPerDay: 0,
          unpaidAmount:
            budgetPerDay?.current * days?.current - prev?.paidAmount,
        }));
        setTotalAmount((prev: any) => ({
          ...prev,
          current: prev?.previous + paidOrUnpaidAmount?.unpaidAmount,
        }));
      } else if (
        // 9 when days reduce and budget increase
        days?.previous > days?.current &&
        budgetPerDay?.previous < budgetPerDay?.current
      ) {
        console.log("case 9");
        setViews((prev: any) => ({
          ...prev,
          current:
            (budgetPerDay?.current + paidOrUnpaidAmount?.dividedAmountPerDay) *
            viewAndClickRate,
        }));
        setClicks((prev: any) => ({
          ...prev,
          current:
            (budgetPerDay?.current + paidOrUnpaidAmount?.dividedAmountPerDay) *
            viewAndClickRate,
        }));
        setPaidOrUnpaidAmount((prev: any) => ({
          ...prev,
          // dividedAmountPerDay: 0,
          unpaidAmount:
            (budgetPerDay?.current + paidOrUnpaidAmount?.dividedAmountPerDay) *
              days?.current -
            prev?.paidAmount,
        }));
        setTotalAmount((prev: any) => ({
          ...prev,
          current: prev?.previous + paidOrUnpaidAmount?.unpaidAmount,
        }));
      }
    } else if (isEdit && isRunningAd?.isRunning) {
      // ad continue and calculate paid 0r unpaid amount and set views and clicks in edit conditions
      if (
        days?.current === days?.previous &&
        budgetPerDay?.current === budgetPerDay?.previous
      ) {
        console.log("Ad continue case 1");
        //1 when days and budget still constant
        setViews((prev: any) => ({
          ...prev,
          current: budgetPerDay?.current * viewAndClickRate,
        }));
        setClicks((prev: any) => ({
          ...prev,
          current: budgetPerDay?.current * viewAndClickRate,
        }));
        setPaidOrUnpaidAmount((prev: any) => ({
          ...prev,
          dividedAmountPerDay: 0,
          unpaidAmount: 0,
        }));
      } else if (
        //2 when days will extend but per day budget will constant
        days?.previous < days?.current &&
        budgetPerDay?.previous === budgetPerDay?.current
      ) {
        console.log("Ad continue case 2");
        setViews((prev: any) => ({
          ...prev,
          current: budgetPerDay?.current * viewAndClickRate,
        }));
        setClicks((prev: any) => ({
          ...prev,
          current: budgetPerDay?.current * viewAndClickRate,
        }));
        setPaidOrUnpaidAmount((prev: any) => ({
          ...prev,
          dividedAmountPerDay: 0,
          unpaidAmount:
            (days?.current - days?.previous) * budgetPerDay?.current,
        }));
        setTotalAmount((prev: any) => ({
          ...prev,
          current: prev?.previous + paidOrUnpaidAmount?.unpaidAmount,
        }));
      } else if (
        // 3 when days will reduce, per day budget is constant
        days?.previous > days?.current &&
        budgetPerDay?.previous === budgetPerDay?.current
      ) {
        let cal =
          ((days?.previous - isRunningAd?.consumeDays) *
            budgetPerDay?.previous -
            (days?.current - isRunningAd?.consumeDays) *
              budgetPerDay?.previous) /
          (days?.current - isRunningAd?.consumeDays);
        console.log("Ad continue case 3");
        setViews((prev: any) => ({
          ...prev,
          current: (cal + budgetPerDay?.current) * viewAndClickRate,
        }));
        setClicks((prev: any) => ({
          ...prev,
          current: (cal + budgetPerDay?.current) * viewAndClickRate,
        }));
        setPaidOrUnpaidAmount((prev: any) => ({
          ...prev,
          dividedAmountPerDay: cal,
          unpaidAmount: 0,
        }));
      } else if (
        // 4 when days will constant, per day budget decrease
        days?.previous === days?.current &&
        budgetPerDay?.previous > budgetPerDay?.current
      ) {
        console.log("Ad continue case 4");
        setViews((prev: any) => ({
          ...prev,
          current: budgetPerDay?.current * viewAndClickRate,
        }));
        setClicks((prev: any) => ({
          ...prev,
          current: budgetPerDay?.current * viewAndClickRate,
        }));
        setPaidOrUnpaidAmount((prev: any) => ({
          ...prev,
          dividedAmountPerDay: 0,
          unpaidAmount: 0,
        }));
      } else if (
        // 5 when days will constant, per day budget increase
        days?.previous === days?.current &&
        budgetPerDay?.previous < budgetPerDay?.current
      ) {
        console.log("Ad continue case 5");
        setViews((prev: any) => ({
          ...prev,
          current: budgetPerDay?.current * viewAndClickRate,
        }));
        setClicks((prev: any) => ({
          ...prev,
          current: budgetPerDay?.current * viewAndClickRate,
        }));
        setPaidOrUnpaidAmount((prev: any) => ({
          ...prev,
          dividedAmountPerDay: 0,
          unpaidAmount:
            (budgetPerDay?.current - budgetPerDay?.previous) *
            isRunningAd?.remainingDays,
        }));
        setTotalAmount((prev: any) => ({
          ...prev,
          current: prev?.previous + paidOrUnpaidAmount?.unpaidAmount,
        }));
      } else if (
        // 6 when days and budget both increase
        days?.previous < days?.current &&
        budgetPerDay?.previous < budgetPerDay?.current
      ) {
        console.log("Ad continue case 6");
        setViews((prev: any) => ({
          ...prev,
          current: budgetPerDay?.current * viewAndClickRate,
        }));
        setClicks((prev: any) => ({
          ...prev,
          current: budgetPerDay?.current * viewAndClickRate,
        }));
        setPaidOrUnpaidAmount((prev: any) => ({
          ...prev,
          dividedAmountPerDay: 0,
          unpaidAmount:
            isRunningAd?.remainingDays *
              (budgetPerDay?.current - budgetPerDay?.previous) +
            (days?.current - days?.previous) * budgetPerDay?.current,
        }));
        setTotalAmount((prev: any) => ({
          ...prev,
          current: prev?.previous + paidOrUnpaidAmount?.unpaidAmount,
        }));
      } else if (
        // 7 when days and budget both decrease
        days?.previous > days?.current &&
        budgetPerDay?.previous > budgetPerDay?.current
      ) {
        console.log("Ad continue case 7");
        setViews((prev: any) => ({
          ...prev,
          current: budgetPerDay?.current * viewAndClickRate,
        }));
        setClicks((prev: any) => ({
          ...prev,
          current: budgetPerDay?.current * viewAndClickRate,
        }));
        setPaidOrUnpaidAmount((prev: any) => ({
          ...prev,
          dividedAmountPerDay: 0,
          unpaidAmount: 0,
        }));
      } else if (
        // 8 when days extend and budget decrease
        days?.previous < days?.current &&
        budgetPerDay?.previous > budgetPerDay?.current
      ) {
        let xxx =
          budgetPerDay?.current * (days?.current - isRunningAd?.consumeDays) -
          paidOrUnpaidAmount?.paidAmount;
        console.log("Ad continue case 8", xxx);
        // setViews((prev: any) => ({
        //   ...prev,
        //   current: budgetPerDay?.current * viewAndClickRate,
        // }));
        // setClicks((prev: any) => ({
        //   ...prev,
        //   current: budgetPerDay?.current * viewAndClickRate,
        // }));
        // setPaidOrUnpaidAmount((prev: any) => ({
        //   ...prev,
        // dividedAmountPerDay: 0,
        //   unpaidAmount:
        //     budgetPerDay?.current * (days?.current - isRunningAd?.consumeDays) -
        //     prev?.paidAmount,
        // }));
        // setTotalAmount((prev: any) => ({
        //   ...prev,
        //   current: prev?.previous + paidOrUnpaidAmount?.unpaidAmount,
        // }));
      } else if (
        // 9 when days reduce and budget increase
        days?.previous > days?.current &&
        budgetPerDay?.previous < budgetPerDay?.current
      ) {
        console.log("Ad continue case 9");
        setViews((prev: any) => ({
          ...prev,
          current: budgetPerDay?.current * viewAndClickRate,
        }));
        setClicks((prev: any) => ({
          ...prev,
          current: budgetPerDay?.current * viewAndClickRate,
        }));
        setPaidOrUnpaidAmount((prev: any) => ({
          ...prev,
          dividedAmountPerDay: 0,
          unpaidAmount:
            (days?.current - isRunningAd?.consumeDays) *
              (budgetPerDay?.current - budgetPerDay?.previous) -
            (days?.previous - days?.current) * budgetPerDay?.previous,
        }));
        setTotalAmount((prev: any) => ({
          ...prev,
          current: prev?.previous + paidOrUnpaidAmount?.unpaidAmount,
        }));
      }
    } else {
      // this condition for craete ad
      setViews((prev: any) => ({
        ...prev,
        current: budgetPerDay?.current * viewAndClickRate,
      }));
      setClicks((prev: any) => ({
        ...prev,
        current: budgetPerDay?.current * viewAndClickRate,
      }));
      setPaidOrUnpaidAmount((prev: any) => ({
        ...prev,
        dividedAmountPerDay: 0,
        unpaidAmount: days?.current * budgetPerDay?.current,
      }));
      setTotalAmount((prev: any) => ({
        ...prev,
        current: days?.current * budgetPerDay?.current,
      }));
    }
  };

  useEffect(() => {
    handleViewAndCliks_andSetPaidOrUnpaidAmount();
  }, [budgetPerDay]);

  const handleChange_Dropdown = (event: any) => {
    setBudgetValue(event.target.value);
  };

  const handleSliderValue = (value: number) => {
    if (isEdit) {
      if (value < budgetPerDay?.previous) {
        setStep2ValidationErrors((prev) => ({
          ...prev,
          budgetValueError:
            "You can't decrease your budget, you have already paid for this.",
        }));
        // setBudgetPerDay((prev: any) => ({
        //   ...prev,
        //   current: value,
        // }));
      } else {
        setBudgetPerDay((prev: any) => ({
          ...prev,
          current: value,
        }));
      }
    } else {
      setBudgetPerDay((prev: any) => ({
        ...prev,
        current: value,
      }));
    }
  };

  const handleDayCounter = (type: string) => {
    let temp;
    if (totalAmount?.previous !== 0) {
      if (type === "decrease" && totalAmount?.previous >= days?.current) {
        return;
      }
    }
    if (type === "increase") {
      // Type here increment code
      temp = days?.current + 1;
      setDays(temp);
      setBudgetPerDay((prev: any) => ({
        ...prev,
        current: budgetPerDay?.current + 1,
      }));
    } else {
      if (days?.current < 1) {
        return null;
      } else {
        // Type here decrement code
        temp = days?.current - 1;
        setDays(temp);
        setBudgetPerDay((prev: any) => ({
          ...prev,
          current: budgetPerDay?.current - 1,
        }));
      }
    }
  };

  const onSubmit = () => {
    // if (budgetValue === "") {
    //     setStep2ValidationErrors(prev => ({
    //         ...prev,
    //         budgetValueError: "Budget is required"
    //     }));
    //     window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    // } else {
    //     setStep2ValidationErrors(prev => ({
    //         ...prev,
    //         budgetValueError: ""
    //     }));
    // };
    if (budgetPerDay?.current === 0) {
      setStep2ValidationErrors((prev) => ({
        ...prev,
        budgetValueError: "Please select your budget",
      }));
      return;
    } else {
      setStep2ValidationErrors((prev) => ({
        ...prev,
        budgetValueError: "",
      }));
    }
    if (budgetValue !== "" && budgetPerDay?.current !== 0) {
      handleViewAndCliks_andSetPaidOrUnpaidAmount();
      // const data = {
      //     budgetPerDay,
      //     budgetValue,
      //     days,
      //     willEndDate?.current
      // };
      // console.log('data', data);
      setFormHandler({
        isShowStep1: false,
        isShowStep2: false,
        isShowStep3: true,
        isShowStep4: false,
      });
    }
  };

  const cancelProduct = () => {
    if (isPromote) {
      history.push(RoutingLinks.adlist);
    } else {
      setFormHandler({
        isShowStep1: true,
        isShowStep2: false,
        isShowStep3: false,
        isShowStep4: false,
      });
    }
  };

  // console.log("isRunningAd :>> ", isRunningAd);
  // console.log("budgetPerDay :>> ", budgetPerDay);
  // console.log(
  //   "New Amount :>> ",
  //   paid
  // );
  // console.log("days :>> ", days);
  // console.log("views :>> ", views);
  // console.log("clicks :>> ", clicks);
  // console.log("paidOrUnpaidAmount :>> ", paidOrUnpaidAmount);
  // console.log("totalAmount :>> ", totalAmount);

  return (
    <Box className={commonStyle.windowColor}>
      <Grid container>
        <Grid item md={3}>
          <LeftSidebar />
          {/* <SocialIconSection /> */}
        </Grid>
        <Grid item md={9}>
          <Box className={commonStyle.p20}>
            <Box className={`${commonStyle.mb15} ${commonStyle.mt30}`}>
              <Typography
                variant="h6"
                className={`${commonStyle.grey} ${commonStyle.fontWeight600} ${commonStyle.f_family_Roboto}`}
              >
                Setting Budget on a Daily Basis
              </Typography>
            </Box>
            <Box pt={3} className={`${commonStyle.p20} ${commonStyle.card}`}>
              <Grid container>
                {/* Dropdown Container //////////// */}
                <Grid item lg={12} md={12} sm={12}>
                  <Typography
                    mb={0.5}
                    variant="h6"
                    className={`${commonStyle.tundora} ${commonStyle.fontWeight400} ${commonStyle.f_family_Roboto} ${commonStyle.font14}`}
                  >
                    Budget
                  </Typography>
                  <FormControl
                    sx={{
                      m: 0,
                      minWidth: 120,
                      width: "100%",
                      borderRadius: "4px",
                    }}
                  >
                    <Select
                      placeholder="Daily Budget"
                      style={{
                        width: "100%",
                        height: 56,
                        borderWidth: 1,
                        borderColor: "#949494",
                      }}
                      value={budgetValue}
                      readOnly
                      // onChange={handleChange_Dropdown}
                      inputProps={{ "aria-label": "Without label" }}
                    >
                      {budgetDropdown.map((item: any) => {
                        return (
                          <MenuItem value={item.option}>{item.option}</MenuItem>
                        );
                      })}
                    </Select>
                  </FormControl>
                  {/* {step2ValidationErrors &&
                    step2ValidationErrors.budgetValueError && (
                      <span className={commonStyle.errorMsg}>
                        {step2ValidationErrors.budgetValueError}
                      </span>
                    )} */}
                </Grid>

                <Grid item lg={12} md={12} sm={12}>
                  <Box
                    mt={9}
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "flex-start",
                      alignItems: "center",
                      gap: "40px",
                    }}
                  >
                    <Typography
                      variant="h6"
                      className={`${commonStyle.dusty_Gray} ${commonStyle.fontWeight500} ${commonStyle.f_family_Roboto} ${commonStyle.font16}`}
                    >
                      {`An estimated ${views?.current?.toFixed(
                        0
                      )} Views and ${clicks?.current?.toFixed(
                        0
                      )} clicks are expected per day.`}
                    </Typography>
                    <Typography
                      variant="h6"
                      className={`${commonStyle.skyBlue} ${commonStyle.fontWeight600} ${commonStyle.f_family_Roboto} ${commonStyle.font48}`}
                    >
                      {`$${
                        isEdit && paidOrUnpaidAmount?.dividedAmountPerDay !== 0
                          ? (
                              paidOrUnpaidAmount?.dividedAmountPerDay +
                              budgetPerDay?.current
                            )?.toFixed(2)
                          : budgetPerDay?.current !== 0
                          ? budgetPerDay?.current.toFixed(2)
                          : "0.00"
                      }`}
                    </Typography>
                    <Box
                      sx={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        gap: "20px",
                      }}
                    >
                      <Typography
                        variant="h6"
                        className={`${commonStyle.silver_Chalice} ${commonStyle.fontWeight500} ${commonStyle.f_family_Roboto} ${commonStyle.font16}`}
                      >
                        {`$1.00`}
                      </Typography>
                      <CustomizedSlider
                        value={budgetPerDay?.current}
                        min={1}
                        max={500}
                        onChange={(event: any) =>
                          handleSliderValue(event.target.value)
                        }
                      />
                      <Typography
                        variant="h6"
                        className={`${commonStyle.silver_Chalice} ${commonStyle.fontWeight500} ${commonStyle.f_family_Roboto} ${commonStyle.font16}`}
                      >
                        {`$500.00`}
                      </Typography>
                    </Box>
                  </Box>
                  {step2ValidationErrors &&
                    step2ValidationErrors.budgetValueError && (
                      <span className={commonStyle.errorMsg}>
                        {step2ValidationErrors.budgetValueError}
                      </span>
                    )}
                </Grid>
                <Grid item lg={6} md={6} sm={12} mt={9} pr={2}>
                  <Typography
                    mb={0.5}
                    variant="h6"
                    className={`${commonStyle.tundora} ${commonStyle.fontWeight400} ${commonStyle.f_family_Roboto} ${commonStyle.font14}`}
                  >
                    Total Day
                  </Typography>
                  <Box
                    px={2}
                    pt={1.8}
                    pb={1.8}
                    className={commonStyle.box_border}
                  >
                    <Box>
                      <Typography
                        mb={0.5}
                        variant="h6"
                        className={`${commonStyle.dusty_Gray} ${commonStyle.fontWeight400} ${commonStyle.f_family_Roboto} ${commonStyle.font14}`}
                      >
                        {days?.current
                          ? `${days?.current}${
                              days?.current < 2 ? " Day" : " Days"
                            }`
                          : "0 Day"}
                      </Typography>
                    </Box>
                    {/* <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: "15px",
                      }}
                    >
                      <img
                        src={Minus}
                        alt=""
                        style={{
                          width: "24px",
                          height: "24px",
                          cursor: "pointer",
                        }}
                        onClick={() => handleDayCounter("decrease")}
                      />
                      <img
                        src={Plus}
                        alt=""
                        style={{
                          width: "24px",
                          height: "24px",
                          cursor: "pointer",
                        }}
                        onClick={() => handleDayCounter("increase")}
                      />
                    </Box> */}
                  </Box>
                </Grid>

                {/* <Grid item lg={6} md={6} sm={12} mt={12.2}>
                  <Box className={commonStyle.commonInput}>
                    <TextField
                      inputProps={{ readOnly: true }}
                      value={
                        days?.current !== 0
                          ? moment(adStartDate?.current)
                              .add(days?.current - 1, "d")
                              .format("MM/DD/YYYY")
                          : "End Date"
                      }
                      className={commonStyle.w100}
                    />
                  </Box>
                </Grid> */}

                <Grid item lg={12} md={12} sm={12} mt={7} mb={5}>
                  <Box className={commonStyle.flexCenter}>
                    <Box
                      className={`${commonStyle.mr10} ${commonStyle.blueBtn}`}
                    >
                      <Button onClick={onSubmit}>
                        {translation("save&continue")}{" "}
                        {/* {disable ? <ClipLoader /> : null} */}
                      </Button>
                    </Box>
                    <Box
                      className={`${commonStyle.mr10} ${commonStyle.greyBtn}`}
                    >
                      <CommonButton
                        onClick={cancelProduct}
                        label={translation("cancel")}
                      />
                    </Box>
                  </Box>
                </Grid>
              </Grid>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default SettingBudget;
